'use es6';

export const ER_CONTACT_PROPERTIES_ALIAS = 'contact properties';
export const ER_EDITOR_ALIAS = 'Editor';
export const ER_CUSTOM_SURVEY_CHECK = 'CustomSurveyCheck';
export const ER_FORM_ALIAS = 'Form';
export const ER_SUBMISSIONS_COLUMN_CONFIG_ALIAS = 'submissions column config';
export const ER_TICKET_PROPERTIES_ALIAS = 'ticket properties';